import { render } from "./phone.vue?vue&type=template&id=304b4c74&scoped=true&ts=true"
import script from "./phone.vue?vue&type=script&lang=ts"
export * from "./phone.vue?vue&type=script&lang=ts"

import "./phone.vue?vue&type=style&index=0&id=304b4c74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304b4c74"]])

export default __exports__